<template>
  <v-container fluid class="e-min-height pa-0">
    <v-flex xs12>
      <div class="e-bg-middle"></div>
    </v-flex>
    <HeaderTransparent :diccionario="false" :buscador="false" />
    <v-container fluid py-2>
      <v-layout row wrap class="fill-height">
        <v-flex xs12>
          <Buscador @clicked="textoBuscador"/>
          <CardProgreso
            :title="this.unidadActual.title"
            :description="this.unidadActual.description"
            :image="require('@/assets/images/unit/menu/' + this.unidadActual.icon)"
            :progress="this.unidadActual.progress"
          />
          <h5 class="e-subTitle my-4">
            <b>Unidades</b>
          </h5>
          <v-progress-circular v-if="loading" :size="50" color="primary" indeterminate></v-progress-circular>
          <carousel
            v-if="!loading"
            :responsive="carouselProperty"
            :margin="10"
            class="e-carousel--unidad"
          >
            <CardUnidad
              v-for="unit in listaUnidades"
              :key="unit.id_unidad"
              :id="unit.id_unidad"
              :unidadInfo="unit.title"
              :descripcion="unit.description"
            />
          </carousel>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import CardProgreso from '../../components/Unidad/CardProgreso'
import CardUnidad from '../../components/Unidad/CardUnidad'
import Buscador from '../../components/Unidad/Global/Buscador'
import { storeFirebase } from '../../store/firebase'

export default {
  components: {
    CardProgreso,
    CardUnidad,
    Buscador
  },
  data () {
    return {
      loading: true,
      textToSearch: '',
      carouselProperty: {
        '0': {
          items: 2,
          nav: false,
          loop: false,
          center: false,
          autoWidth: true,
          dots: false
        },
        '768': {
          items: 6,
          nav: false,
          loop: false,
          center: false,
          dots: true
        }
      },
      listaUnidades: [],
      unidadActual: {
        title: 'loading..',
        description: 'loading..',
        icon: 'mainImage.png',
        progress: 5
      }
    }
  },
  created () {
    this.loadUnits()
  },
  computed: {
    unitsList () {
      this.listaUnidades = storeFirebase.getters.loadedUnits
      return this.listaUnidades
    }
  },
  methods: {
    loadUnits () {
      storeFirebase.dispatch('loadUnits').then(() => {
        setTimeout(() => {
          this.listaUnidades = storeFirebase.getters.loadedUnits
          this.loadProgress();
        }, 2500)
      })
    },
    loadProgress () {
      const progress = storeFirebase.getters.userProgress
      const unitNumber = progress.count.units;
      const currentUnit = 'unit_' + unitNumber
      const currentProgress = progress.units[currentUnit]
      if (currentProgress === 100) {
        if (unitNumber < 22) {
          progress.count.units = (unitNumber + 1)
          this.updateUserProgress(progress)
        }
      }
      const unidad = this.listaUnidades.filter(uni => uni.id_unidad == progress.count.units)
      if (unidad.length > 0) {
        const unitVal = 'unit_' + unidad[0].id_unidad
        const unidProgress = progress.units[unitVal]
        this.unidadActual = {
          title: unidad[0].title,
          description: unidad[0].description,
          icon: unidad[0].icon,
          progress: unidProgress
        }
      }
      this.loading = false
    },
    textoBuscador ( values ) {
      this.loading = true
      this.textToSearch = values
      if ( this.textToSearch.length > 0) {
        this.listaUnidades = []
        setTimeout(() => {
          this.loading = false
          this.listaUnidades = storeFirebase.getters.loadedUnits.filter( value => value.title.includes( this.textToSearch ))
        }, 2000)
      } else {
        setTimeout(() => {
          this.loading = false
          this.listaUnidades = storeFirebase.getters.loadedUnits
        }, 2000)
      }
    },
    updateUserProgress(newUserProgress) {
      storeFirebase.dispatch('updateUserProgress', newUserProgress)
    }
  }
}
</script>
